

export default function Header(props){

    const { 
        title = ""
    } = props;

    return (
        <h1
            style={{marginTop: '0px'}}
        >
            { title }
        </h1>
    )
}